var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.clickOutside,
          expression: "clickOutside"
        }
      ],
      staticClass: "carousel"
    },
    [
      _c("vue-horizontal-list", {
        ref: "horizontalList",
        attrs: {
          items: _vm.mapViewData.places,
          options: _vm.horizontalListOptions
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "div",
                  {
                    staticClass: "item",
                    class: { active: _vm.isActive(item) },
                    on: {
                      click: function($event) {
                        return _vm.itemClicked(item)
                      }
                    }
                  },
                  [
                    _c(
                      "v-card",
                      { staticClass: "card" },
                      [
                        _c("v-img", {
                          staticClass: "carousel-item-img",
                          attrs: {
                            src: _vm.imagePath(item),
                            "aspect-ratio": "2.75"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "v-card-title",
                          {
                            staticClass: "card-title",
                            attrs: { "primary-title": "" }
                          },
                          [
                            _c("div", { staticClass: "place-data" }, [
                              _c(
                                "h3",
                                {
                                  staticClass: "title ellipsis mb-0",
                                  attrs: { title: item.placeName }
                                },
                                [_vm._v(_vm._s(item.placeName))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "ellipsis" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.getItemLayer(item)))
                                ]),
                                _vm._v(" "),
                                item.properties.locality
                                  ? _c("span", [
                                      _vm._v(
                                        " - " + _vm._s(item.properties.locality)
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(item.properties.country_a))
                                ])
                              ]),
                              _vm._v(" "),
                              item.properties.distance
                                ? _c("div", { staticClass: "distance" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("placesCarousel.distance")
                                        ) +
                                        "\n                "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "placesCarousel.distanceFromLocationMarkedOnTheMap"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.properties.distance.toFixed(1)
                                          ) +
                                            " " +
                                            _vm._s(_vm.$t("global.units.km"))
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs5: "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "navigate-btn",
                                        on: {
                                          click: function($event) {
                                            return _vm.gotToPlace(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "placesCarousel.selectPlace"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "icon",
                                            attrs: { right: "", dark: "" }
                                          },
                                          [_vm._v("place")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-spacer"),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { xs6: "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "navigate-btn",
                                        on: {
                                          click: function($event) {
                                            return _vm.directionsTo(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "placesCarousel.directionsTo"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "icon",
                                            attrs: { right: "", dark: "" }
                                          },
                                          [_vm._v("directions")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "previous",
          attrs: { icon: "" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.previous()
            }
          }
        },
        [
          _c(
            "v-icon",
            { attrs: { large: "", title: _vm.$t("placesCarousel.prev") } },
            [_vm._v("keyboard_arrow_left ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "next",
          attrs: { icon: "" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.next()
            }
          }
        },
        [
          _c(
            "v-icon",
            { attrs: { large: "", title: _vm.$t("placesCarousel.next") } },
            [_vm._v("keyboard_arrow_right ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7120ad3f", { render: render, staticRenderFns: staticRenderFns })
  }
}